import { render } from "./sf-input-error.vue?vue&type=template&id=2cab4a3b&ts=true"
import script from "./sf-input-error.vue?vue&type=script&lang=ts"
export * from "./sf-input-error.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__